// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"82":"e8dec7efcdc6dc08","657":"1bd95b5a858d1212","1343":"c2e2e9d696224ff3","3527":"926912822e71486e"}[chunkId] + ".css";
};